export default __webpack_public_path__ + "static/media/Martin_Alvarez.2dceb9e3.png";